const downloadInvoicePDF = async (invoiceData) => {
  const url = invoiceData?.invoice_url;
  const fileName = `Invoice-${invoiceData?.invoice_no || 'Download'}.pdf`;

  if (!url) {
    console.error("No invoice URL provided");
    return;
  }

  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

    const blob = await response.blob();

    // ── This part forces download ──
    const blobUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = fileName;           // ← key line
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(blobUrl);
    // ─────────────────────────────────
  } catch (error) {
    console.error("Download failed:", error);
    // Fallback — only used when fetch is blocked (most common: CORS)
    window.open(url, "_blank");       // ← this is what opens the tab/preview
  }
};

export default downloadInvoicePDF;